import api from '../../../services/api';

class BookingService {
  /**
   * Create a new booking
   */
  async createBooking(bookingData) {
    try {
      const response = await api.post('/bookings', bookingData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get user's bookings
   */
  async getUserBookings(page = 1, limit = 10, filters = {}) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...filters,
      });

      const response = await api.get(`/bookings?${params}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get booking by ID
   */
  async getBookingById(bookingId) {
    try {
      const response = await api.get(`/bookings/${bookingId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Update booking status
   */
  /**
   * `paymentReceived` answers "has the customer paid?" when completing a job.
   * Omitting it makes the backend assume cash was collected, so always pass it
   * explicitly on a transition to `completed`.
   */
  async updateBookingStatus(bookingId, status, paymentReceived = undefined) {
    try {
      const payload = { status };
      if (paymentReceived !== undefined) payload.paymentReceived = paymentReceived;
      const response = await api.patch(`/bookings/${bookingId}/status`, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Assign technician to booking (Admin only)
   */
  async assignTechnician(bookingId, technicianId) {
    try {
      const response = await api.post(`/bookings/${bookingId}/assign`, { technicianId });
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Cancel booking
   */
  async cancelBooking(bookingId, reason) {
    try {
      const response = await api.post(`/bookings/${bookingId}/cancel`, { reason });
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get booking statistics (Admin only)
   */
  async getBookingStats() {
    try {
      const response = await api.get('/bookings/stats');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new BookingService();
